import * as debtAnalysisConfigActions from '../actions/debt-analysis-widget-configuration.actions';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { DebtAnalysisWidgetConfiguration } from '../models/debt-analysis-widget-configuration.model';

export class DebtAnalysisWidgetConfigurationInstance extends DebtAnalysisWidgetConfiguration {
  constructor(public id: number, public loading: boolean, public error?: any) {
    super();
    this.WidgetConfigurationId = this.id;
  }
}

export const adapter = createEntityAdapter<DebtAnalysisWidgetConfigurationInstance>();

export interface DebtAnalysisWidgetConfigurationsState extends EntityState<DebtAnalysisWidgetConfigurationInstance> {
  loading: boolean;
  error: any;
}

export const initialState = adapter.getInitialState({
  loading: false,
  error: undefined
});

export function reducer(
  state = initialState,
  action: debtAnalysisConfigActions.Actions): DebtAnalysisWidgetConfigurationsState {

  switch (action.type) {
    case debtAnalysisConfigActions.LOAD_ALL:
      {
        return adapter.removeAll({ ...state, loading: true, error: undefined });
      }
    case debtAnalysisConfigActions.LOAD_ALL_COMPLETE:
      {
        adapter.removeAll(state);
        const items = action.payload.configs.map(item => {
          return { ... new DebtAnalysisWidgetConfigurationInstance(item.WidgetConfigurationId, false), ...item }
        });
        return adapter.addMany(items, state);
      }
    case debtAnalysisConfigActions.LOAD_ALL_ERROR:
      {
        return { ...state, loading: false, error: action.payload.error };
      }
    default:
      return state;
  }
}

